import libUseToast, {
  ToastMethod,
  type UseToastConfig,
} from 'lib/utils/baseToast.util';

export type * from 'lib/utils/baseToast.util';

export const useToastConfig: UseToastConfig = {
  icons: {
    success: 'emotion-happy-fill',
    error: 'emotion-unhappy-fill',
  },
};

const useToast = (): ToastMethod => {
  return libUseToast(useToastConfig);
};

export default useToast;
